import api from "@/api";

export default {
    getActivity(taskId,params) {
    return api.get(`/api/nhat-ky-hoat-dong/${taskId}`, {params});
  },
};